import React from "react";
import TissuesList from "./_TissuesList";
import DrawnTissuesList from "./_DrawnTissuesList";
import QualitiessList from "./_QualitiesList";

const ExamSidebar = (props) => {
  let {
    tissues,
    selectTissue,
    selectQuality,
    saveTissueCordinates,
    showDrawnTissue,
    removeTissue,
    answerQuestion,
    currentTissueSelected,
    currentQuestionIndex,
    questions,
    isTissueImageGenerated,
  } = props;
  return (
    <div className="sidebar-actions">
      <div className="row">
        <div className="col-sm-1 hide-on-desktop"></div>

        <div className="col-lg-12 col-md-5 col-sm-5">
          <div
            className="form-group col-lg-12 col-md-12"
            id="tissues-list-select"
          >
            <p>Overall Frame Quality.</p>

            <QualitiessList selectQuality={selectQuality} />
            {/* <i className="fas fa-plus" onClick={saveTissueCordinates} /> */}
          </div>
        </div>

        <div className="col-lg-12 col-md-5 col-sm-5">
          <div
            className="form-group col-lg-12 col-md-12"
            id="tissues-list-select"
          >
            <p>Add ROI for all tissues in the image.</p>

            <TissuesList selectTissue={selectTissue} />
            {/* <i className="fas fa-plus" onClick={saveTissueCordinates} /> */}
          </div>
          <div className="tissues-list col-lg-12 col-md-12">
            <DrawnTissuesList
              tissues={tissues}
              showDrawnTissue={showDrawnTissue}
              removeTissue={removeTissue}
              isTissueImageGenerated={isTissueImageGenerated}
            />
          </div>
        </div>

        <div className="col-lg-12 col-md-6">
          {currentTissueSelected !== "nothing-detected" && (
            <>
              <button
                className="btn btn-orange save-roi-btn"
                onClick={saveTissueCordinates}
                id="save-roi-btn"
              >
                Save ROI
              </button>
              <button
                className="btn btn-orange save-roi-btn"
                id="save-roi-btn-overlay"
              >
                Save ROI
              </button>
            </>
          )}
          <>
            <button
              className="btn btn-orange next-btn"
              id="complete-image-btn"
              onClick={answerQuestion}
              disabled={!isTissueImageGenerated}
            >
              {questions.length === currentQuestionIndex + 1
                ? "Complete Case"
                : "Next Image"}
            </button>

            <button
              className="btn btn-orange next-btn"
              id="complete-image-btn-overlay"
            >
              {questions.length === currentQuestionIndex + 1
                ? "Complete Case"
                : "Next Image"}
            </button>
          </>
        </div>
      </div>
    </div>
  );
};

export default ExamSidebar;
